<div class="users" *ngIf="isDataLoaded" [class.compact-cols]="isBeecher || isMidMarket">
  <div class="user-list-header">
    <cygov-checkbox class="user-list-checkbox" [isChecked]="allUserSelected" cygovUserPermission
      (changed)="onSelectAll($event)">
    </cygov-checkbox>
    <cygov-user-list-header (onDeleted)="onDeleted($event)" (onUnselectAll)="onSelectAll(false)"
      [selectedUsers]="selectedUsers" [userList]="userList" (onSortChanged)="onSortChanged($event)"
      [isEditMode]="isEditMode">
    </cygov-user-list-header>
  </div>
  <!-- <div class="horizontal-separator"></div> -->
  <div class="users-wrapper">
    <!-- The list's own load renders skeleton rows, so the section keeps its shape instead of
         showing an empty table until the users arrive. -->
    <ng-container *ngIf="isLoading">
      <div class="td-users d-flex" *ngFor="let row of listSkeletonRows">
        <div class="user-item-margin">
          <div class="user-item-container">
            <ng-container *ngTemplateOutlet="userSkeletonRow"></ng-container>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- A user being created holds the top slot, which is where the real row lands. -->
    <div class="td-users d-flex" *ngIf="isCreatingUser">
      <div class="user-item-margin">
        <div class="user-item-container">
          <ng-container *ngTemplateOutlet="userSkeletonRow"></ng-container>
        </div>
      </div>
    </div>
    <div *ngFor="let viewPortItem of (isLoading ? [] : userListToShow);let i = index"
      class="td-users d-flex">
      <div class="user-item-margin"
        *ngIf="(showUserDetail && viewPortItem.id == selectedUser) || !showUserDetail">
        <div class="user-item-container" [ngClass]="{ 'selected': viewPortItem.isSelected  }"
          (click)="!isUserBusy(viewPortItem) && viewPortItem?.isLowerRank && toggleList(viewPortItem)">
          <!-- A row with a save or delete in flight keeps its place in the table as a skeleton,
               and returns to real data when the request settles. -->
          <ng-container *ngIf="isUserBusy(viewPortItem); else userRowContent">
            <ng-container *ngTemplateOutlet="userSkeletonRow"></ng-container>
          </ng-container>
          <ng-template #userRowContent>
            <div *ngIf="(currentUserId !== viewPortItem.user.id);then checkbox else spaces">
            </div>
            <ng-template #checkbox>
              <cygov-checkbox class="user-list-checkbox" [id]="'user_'+ viewPortItem.id"
                [isChecked]="viewPortItem.isSelected" cygovUserPermission
                (changed)="viewPortItem?.isLowerRank && viewPortItem.isSelected = $event; updateSelected(viewPortItem)">
              </cygov-checkbox>
            </ng-template>
            <ng-template #spaces>
              <div [ngClass]="{'extra-space': !isViewOnly }"></div>
            </ng-template>
            <cygov-user-item (onUpdateItem)="onUpdateItem($event)" class="user-item"
              [item]="viewPortItem" [isEditable]="viewPortItem?.isLowerRank"
              [isVendorUser]="isVendorUser(viewPortItem?.user)" [rolesList]="rolesList"
              [childEntities]="childEntities" [vendorEntities]="vendorHashEntities"
              [rootEntity]="rootEntity" (userUpdated)="isSetUpdate($event, viewPortItem)"
              [currentUser]="currentUser" [openUpwards]="getOpenUpwards(i, userListToShow.length)">
            </cygov-user-item>
          </ng-template>
        </div>
        <div class="container-fluid userDetailTabSet"
          *ngIf="(isLoading || showUserDetail) && viewPortItem.id === selectedUser">
        </div>
      </div>
    </div>
    <div *ngIf="userList.length === 0 && !isCreatingUser && !isLoading"
      class="td-users d-flex-c no-record">
      No Record Found
    </div>
  </div>
</div>

<!-- One skeleton row, used both while a new user is being created and while an existing row's
     save or delete is in flight, so the two can never drift apart. -->
<ng-template #userSkeletonRow>
  <div class="user-skeleton-row">
    <!-- the checkbox column stays empty, as it does in the other tables' skeleton rows -->
    <div class="skeleton-checkbox-cell"></div>
    <div class="td-inner-skeleton" *ngFor="let column of skeletonColumns" [ngClass]="column.class">
      <cygov-skeleton [width]="skeletonWidthFor(column.value)" height="1.6vh"></cygov-skeleton>
    </div>
  </div>
</ng-template>
